import { insert, query, remove, update } from '../db'
import { today as todayISO } from '../lib/dates'
import { uid } from '../lib/id'
import { round2 } from '../lib/money'
import { cadenceOf } from '../lib/savings'
import { state } from './state'

export async function loadGoals() {
  state.goals = await query(
    'SELECT * FROM goals ORDER BY archived, priority DESC, created_at',
  )
  return state.goals
}

function normalise(input) {
  const byAmount = input.pace_mode === 'by_amount'
  return {
    name: (input.name ?? '').trim(),
    target_amount: Math.abs(round2(Number(input.target_amount) || 0)),
    initial_amount: Math.abs(round2(Number(input.initial_amount) || 0)),
    pace_mode: byAmount ? 'by_amount' : 'by_date',
    target_date: byAmount ? null : input.target_date || null,
    monthly_amount: byAmount ? Math.abs(round2(Number(input.monthly_amount) || 0)) : null,
    cadence: cadenceOf(input),
    // The day the pretending starts, and the anchor the instalments count from.
    start_date: input.start_date || todayISO(),
    priority: Number(input.priority ?? 0),
    archived: input.archived ? 1 : 0,
  }
}

export async function addGoal(input) {
  const now = new Date().toISOString()
  const row = { id: uid('gl'), ...normalise(input), created_at: now, updated_at: now }
  await insert('goals', row)
  await loadGoals()
  return row
}

export async function updateGoal(id, input) {
  await update('goals', id, { ...normalise(input), updated_at: new Date().toISOString() })
  await loadGoals()
}

export async function deleteGoal(id) {
  // Nothing in the ledger points at a goal, so deleting one only gives the
  // money back.
  await remove('goals', id)
  await loadGoals()
}

export async function toggleGoalArchived(id, archived) {
  await update('goals', id, { archived: archived ? 1 : 0, updated_at: new Date().toISOString() })
  await loadGoals()
}
